import Picture from "./components/Picture";
import "./styles/style.css"

function App() {
  return (
    <div>
        <h1 style={{textAlign:"center"}}>İmage Gallery</h1>
        <Picture/>
    </div>
  );
}

export default App;
